import { useQuery, type QueryClient } from '@tanstack/react-query';
import { documentApi } from '../api';
import { queryKeys } from './keys';

/** The level a drawing opens at, before the canvas knows its zoom. */
export const INITIAL_PNID_IMAGE_LEVEL = 4096;

// A sheet image never changes under its document id, so one download per level
// serves every mount for the session. A failed download is tried once, so a 401
// signs the user out once.
const pnidImageQueryOptions = (docId: string, level: number) => ({
  queryKey: queryKeys.pnidImage(docId, level),
  queryFn: () => documentApi.getPnidImage(docId, level),
  staleTime: Infinity,
  retry: false,
});

/** The sheet image of `docId` at `level`. Without a `docId` the query stays idle. */
export function usePnidImage(docId: string | undefined, level: number) {
  return useQuery({
    ...pnidImageQueryOptions(docId ?? '', level),
    enabled: Boolean(docId),
  });
}

/** Starts the download ahead of the canvas, so the canvas mounts onto a cached image. */
export function prefetchPnidImage(queryClient: QueryClient, docId: string, level: number): Promise<void> {
  return queryClient.prefetchQuery(pnidImageQueryOptions(docId, level));
}
